// import React from "react";
// import { PhotoPlaceholder } from "../photo-placeholder";

// // Simple ScrollArea component
// function ScrollArea({ children, className }) {
//   return (
//     <div
//       className={`overflow-auto ${className}`}
//       style={{ scrollbarWidth: "thin", scrollbarColor: "#cbd5e1 #f1f5f9" }}
//     >
//       {children}
//     </div>
//   );
// }

// export function SpeakersSection() {
//   return (
//     <div className="space-y-6">
//       <h2 className="text-2xl font-semibold">Speakers</h2>
//       <p className="text-muted-foreground">
//         Plenary, Keynote, and Prominent Speakers from India and abroad. Featured institutions include ETH Zurich,
//         Indiana University, NC State University, University of California Riverside, Washington State University, Johns
//         Hopkins, University of Alabama, IITs, AIIMS, IISc, PGIMER, and more.
//       </p>

//       {/* Plenary & Keynote Speakers */}
//       <div className="rounded-lg border p-4">
//         <h3 className="font-medium">Plenary &amp; Keynote Speakers</h3>
//         <ul className="text-sm text-muted-foreground grid gap-1 mt-2">
//           <li>• Prof. David B. Burr — Indiana University, USA</li>
//           <li>• Prof. (Dr.) Ralph Müller — ETH Zurich, Switzerland</li>
//           <li>• Prof. Roger J. Narayan — NC State University, USA</li>
//           <li>• Prof. Huinan Hannah Liu — University of California, Riverside, USA</li>
//           <li>• Prof. Amit Bandyopadhyay — Washington State University, USA</li>
//           <li>• Prof. Ketul C. Popat — George Mason University, USA</li>
//           <li>• Prof. Dhirendra S. Katti — President (STERMI), Director, IIT Goa, India</li>
//           <li>• Prof. Savyasachi C. Thakkar — Johns Hopkins University, USA</li>
//           <li>• Prof. Vinoy Thomas — University of Alabama, USA</li>
//           <li>• Prof. Bikramjit Basu — Director, CSIR-CGCRI</li>
//           <li>• Dr. Prashant N. Kumta — University of Pittsburgh, USA</li>
//           <li>• Prof. Ashok Kumar — President (SBAOI), IIT Kanpur, India</li>
//           <li>• Dr. Jitendra Sharma — MD &amp; Founder, AMTZ, India</li>
//           <li>• Prof. Ashutosh Khandha — University of Delaware, USA</li>
//           <li>• Prof. Chandan K. Sen — University of Pittsburgh, USA</li>
//           <li>• Prof. Gilson Khang — Jeonbuk National University, Korea</li>
//         </ul>
//       </div>

//       {/* International and National Speakers */}
//       <div className="grid gap-6 md:grid-cols-2">
//         <div className="rounded-lg border p-4">
//           <h3 className="font-medium">International Prominent Speakers</h3>
//           <ScrollArea className="h-48 mt-2">
//             <ul className="text-sm text-muted-foreground grid gap-1 pr-4">
//               <li>• Prof. Manishekhar Kumar — University of Pittsburgh, USA</li>
//               <li>• Dr. Binata Joddar — Oregon State University, USA</li>
//               <li>• Prof. Sriya Srinivasan — Kempner Institute, USA</li>
//               <li>• Prof. Anamika Prasad — Florida International University, USA</li>
//             </ul>
//           </ScrollArea>
//         </div>

//         <div className="rounded-lg border p-4">
//           <h3 className="font-medium">National Prominent Speakers</h3>
//           <ScrollArea className="h-48 mt-2">
//             <ul className="text-sm text-muted-foreground grid gap-1 pr-4">
//               <li>• Prof. Anil K. Bhat — KMC, Manipal</li>
//               <li>• Prof. Rehan Haq — AIIMS Bhopal</li>
//               <li>• Prof. Atul Parashar — PGIMER, Chandigarh</li>
//               <li>• Prof. Bishnu P. Patro — AIIMS Bhubaneswar</li>
//               <li>• Col. Dr. Manish Prasad — Orthopaedics, Delhi</li>
//               <li>• Dr. Vikas Jain — Founder, Aarogyam 3D Design</li>
//               <li>• Prof. Bhavuk Garg — AIIMS, New Delhi</li>
//               <li>• Prof. Pravin Salunke — Neurosurgery, PGIMER</li>
//               <li>• Prof. Sujata Mohanty — Stem Cell, AIIMS Delhi</li>
//               <li>• Prof. Namrata Gundiah — Mechanical Engg., IISc Bengaluru</li>
//               <li>• Prof. Sarvdeep Singh Dhatt — Ortho., PGIMER Chandigarh</li>
//               <li>• Prof. Vishal Kumar — Addl. Prof. Ortho., PGIMER</li>
//               <li>• Prof. Neetu Singh — Head, Biomedical, IIT Delhi</li>
//               <li>• Prof. Subha Narayan Rath — Biomedical Engg., IIT Hyderabad</li>
//               <li>• Dr. Dinesh Kalyanasundaram — Biomedical, IIT Delhi</li>
//               <li>• Dr. Akshay Srivastava — Medical Device, NIPER Ahmedabad</li>
//               <li>• Prof. Kumar Keshav — Orthopaedic, SGPGIMS Lucknow</li>
//               <li>• Prof. Falguni Pati — Head, Biomed, IIT Hyderabad</li>
//               <li>• Prof. Kulbhushan Tikoo — Dean, NIPER Mohali</li>
//               <li>• Prof. Kaushik Chatterjee — Chair, Bioengineering, IISc Bengaluru</li>
//               <li>• Dr. P. R. Harikrishna Varma — SCTIMST, Trivandrum</li>
//               <li>• Prof. Shalmoli Bhattacharyya — Head, Biophysics, PGIMER</li>
//               <li>• Dr. Bhanu Duggal — HOD, Cardiology, AIIMS Rishikesh</li>
//               <li>• Prof. Biman B. Mandal — IIT Guwahati</li>
//               <li>• Dr. Finosh G. Thankam — Western University of Health Sciences, USA</li>
//             </ul>
//           </ScrollArea>
//         </div>
//       </div>

//       <PhotoPlaceholder label="Speaker headshots & dignitary photos (add later)" />
//     </div>
//   );
// }

"use client";

import React from "react";
import { motion } from "framer-motion";

/* -----------------------------------------------------------------------------
   Local ScrollArea
----------------------------------------------------------------------------- */
function ScrollArea({ children, className }) {
  return (
    <div
      className={`overflow-auto rounded-lg bg-gradient-to-b from-slate-50/80 to-white p-3 shadow-inner ${className}`}
      style={{
        scrollbarWidth: "thin",
        scrollbarColor: "#cbd5e1 #f8fafc",
      }}
    >
      {children}
    </div>
  );
}

/* -----------------------------------------------------------------------------
   Animation Variants
----------------------------------------------------------------------------- */
const fadeUp = (delay = 0) => ({
  hidden: { opacity: 0, y: 24 },
  show: {
    opacity: 1,
    y: 0,
    transition: { delay, duration: 0.6, ease: "easeOut" },
  },
});

/* -----------------------------------------------------------------------------
   Component
----------------------------------------------------------------------------- */
export function SpeakersSection() {
  return (
    <motion.section
      className="space-y-12"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.25 }}
      transition={{ staggerChildren: 0.2 }}
    >
      {/* Header */}
      <motion.div variants={fadeUp(0)}>
        
        <p className="text-muted-foreground mt-4 max-w-3xl text-md leading-relaxed">
          BioMANTHAN 2025 proudly features distinguished speakers from
          world-renowned institutions, including ETH Zurich, Indiana University,
          NC State University, University of California Riverside, Johns
          Hopkins, IITs, AIIMS, IISc, and more.
        </p>
      </motion.div>

      {/* Keynote Speakers */}
      <motion.div
        variants={fadeUp(0.15)}
        className="rounded-2xl border border-gray-400 bg-gradient-to-br from-white to-slate-50/80 backdrop-blur-sm shadow-md p-8 hover:shadow-lg transition-all duration-300"
      >
        <h3 className="font-semibold text-xl text-blue-500 mb-4 border-b border-indigo-100 pb-2">
          Plenary &amp; Keynote Speakers
        </h3>
        <ul className="text-sm  text-muted-foreground grid gap-2 leading-relaxed list-disc list-inside">
          {[
            "Prof. David B. Burr — Indiana University, USA",
            "Prof. (Dr.) Ralph Müller — ETH Zurich, Switzerland",
            "Prof. Roger J. Narayan — NC State University, USA",
            "Prof. Huinan Hannah Liu — University of California, Riverside, USA",
            "Prof. Amit Bandyopadhyay — Washington State University, USA",
            "Prof. Ketul C. Popat — George Mason University, USA",
            "Prof. Dhirendra S. Katti — Director, IIT Goa, India",
            "Prof. Savyasachi C. Thakkar — Johns Hopkins University, USA",
            "Prof. Vinoy Thomas — University of Alabama, USA",
            "Prof. Bikramjit Basu — Director, CSIR-CGCRI, India",
            "Dr. Prashant N. Kumta — University of Pittsburgh, USA",
            "Prof. Ashok Kumar — President (SBAOI), IIT Kanpur, India",
            "Dr. Jitendra Sharma — MD & Founder, AMTZ, India",
            "Prof. Ashutosh Khandha — University of Delaware, USA",
            "Prof. Chandan K. Sen — University of Pittsburgh, USA",
            "Prof. Gilson Khang — Jeonbuk National University, Korea",
          ].map((speaker, i) => (
            <motion.li key={i} variants={fadeUp(0.03 * i)}>
              {speaker}
            </motion.li>
          ))}
        </ul>
      </motion.div>

      {/* International & National Speakers */}
      <motion.div
        variants={fadeUp(0.25)}
        className="grid gap-8 md:grid-cols-2"
      >
        {/* International */}
        <motion.div
          variants={fadeUp(0.3)}
          className="rounded-xl border border-gray-400 bg-gradient-to-br from-white to-indigo-50/40 shadow-sm hover:shadow-md p-6 transition-transform hover:scale-[1.01]"
        >
          <h3 className="font-semibold text-xl text-blue-500 mb-3 border-b border-indigo-100 pb-1">
            International Prominent Speakers
          </h3>
          <ScrollArea className="h-56">
            <ul className="text-sm  text-muted-foreground grid gap-2 leading-relaxed list-disc list-inside pr-3">
              {[
                "Prof. Manishekhar Kumar — University of Pittsburgh, USA",
                "Dr. Binata Joddar — Oregon State University, USA",
                "Prof. Sriya Srinivasan — Kempner Institute, USA",
                "Prof. Anamika Prasad — Florida International University, USA",
              ].map((speaker, i) => (
                <motion.li key={i} variants={fadeUp(0.04 * i)}>
                  {speaker}
                </motion.li>
              ))}
            </ul>
          </ScrollArea>
        </motion.div>

        {/* National */}
        <motion.div
          variants={fadeUp(0.4)}
          className="rounded-2xl border border-gray-400 bg-gradient-to-br from-white to-pink-50/40 shadow-sm hover:shadow-md p-6 transition-transform hover:scale-[1.01]"
        >
          <h3 className="font-semibold text-xl text-blue-500 mb-3 border-b border-indigo-100 pb-1">
            National Prominent Speakers
          </h3>
          <ScrollArea className="h-56">
            <ul className="text-sm  text-muted-foreground grid gap-2 leading-relaxed list-disc list-inside pr-3">
              {[
                "Prof. Anil K. Bhat — KMC, Manipal",
                "Prof. Rehan Haq — AIIMS Bhopal",
                "Prof. Atul Parashar — PGIMER, Chandigarh",
                "Prof. Bishnu P. Patro — AIIMS Bhubaneswar",
                "Col. Dr. Manish Prasad — Orthopaedics, Delhi",
                "Dr. Vikas Jain — Founder, Aarogyam 3D Design",
                "Prof. Bhavuk Garg — AIIMS, New Delhi",
                "Prof. Pravin Salunke — Neurosurgery, PGIMER",
                "Prof. Sujata Mohanty — Stem Cell, AIIMS Delhi",
                "Prof. Namrata Gundiah — Mechanical Engg., IISc Bengaluru",
                "Prof. Sarvdeep Singh Dhatt — Ortho., PGIMER Chandigarh",
                "Prof. Vishal Kumar — Addl. Prof. Ortho., PGIMER",
                "Prof. Neetu Singh — Biomedical, IIT Delhi",
                "Prof. Subha Narayan Rath — Biomedical Engg., IIT Hyderabad",
                "Dr. Dinesh Kalyanasundaram — Biomedical, IIT Delhi",
                "Dr. Akshay Srivastava — Medical Device, NIPER Ahmedabad",
                "Prof. Kumar Keshav — Orthopaedic, SGPGIMS Lucknow",
                "Prof. Falguni Pati — Head, Biomed, IIT Hyderabad",
                "Prof. Kulbhushan Tikoo — Dean, NIPER Mohali",
                "Prof. Kaushik Chatterjee — Chair, Bioengineering, IISc Bengaluru",
                "Dr. P. R. Harikrishna Varma — SCTIMST, Trivandrum",
                "Prof. Shalmoli Bhattacharyya — Head, Biophysics, PGIMER",
                "Dr. Bhanu Duggal — HOD, Cardiology, AIIMS Rishikesh",
                "Prof. Biman B. Mandal — IIT Guwahati",
                "Dr. Finosh G. Thankam — Western University of Health Sciences, USA",
              ].map((speaker, i) => (
                <motion.li key={i} variants={fadeUp(0.02 * i)}>
                  {speaker}
                </motion.li>
              ))}
            </ul>
          </ScrollArea>
        </motion.div>
      </motion.div>

      {/* Placeholder */}
      {/* <motion.div variants={fadeUp(0.6)} className="pt-4">
        <PhotoPlaceholder label="Speaker headshots & dignitary photos (coming soon)" />
      </motion.div> */}
    </motion.section>
  );
}
